import React, { useCallback } from 'react';
import { useAnimatedScrollHandler } from 'react-native-reanimated';
import { StyleSheet, TouchableHighlight } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { US_STATES } from 'features/borrow/monevo/models';
import { ModalFlatList } from '../ModalScrollables';
const USStatePickerModalContent = ({ closeModal, sharedValue, finalHeight, onSelectState, }) => {
    const colors = useColors();
    const contentContainerStyles = useMarginBottom('paddingBottom');
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        sharedValue.value = handle.contentOffset.y;
    }, []);
    const handlePress = useCallback((item) => () => {
        closeModal();
        onSelectState(item);
    }, [closeModal, onSelectState]);
    const renderItem = useCallback(({ item }) => (<TouchableHighlight style={styles.stateItem} onPress={handlePress(item)} underlayColor={colors.background.underlay}>
        <Text Text-16>{item.label}</Text>
      </TouchableHighlight>), [colors.background.underlay, handlePress]);
    return (<ModalFlatList data={US_STATES} renderItem={renderItem} scrollEventThrottle={16} onScroll={scrollHandler} style={{ height: finalHeight }} contentContainerStyle={contentContainerStyles}/>);
};
const finalHeight = rem(600);
export const USStatePickerModal = {
    show: (sharedValue, onSelectState) => {
        Modal.show(<USStatePickerModalContent closeModal={Modal.hide} finalHeight={finalHeight} sharedValue={sharedValue} onSelectState={onSelectState}/>, {
            containerStyle: styles.modal,
            title: 'Choose state',
            scrollable: {
                maxHeight: finalHeight,
                scrollValue: sharedValue,
            },
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    stateItem: {
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
});
